import React from 'react';
import Form, { Actions, EmailAddressValidator, Password, RequiredValidator, TextField } from '../../Components/Form';
import Card from '../../Components/Containers/Card';
import { Link, useNavigate } from 'react-router-dom';
import { useSession } from '../../Components/Session';
import ButtonBar from '../../Components/Button/ButtonBar';
import { useStatusBarColour } from '../../Components/Mobile';

const Login = () => {
    const {login} = useSession();
    const navigate = useNavigate();

    useStatusBarColour('#F8F9FA');

    return <>
        <img src="/logo-name-horizontal.png"
            alt="getSoapy Logo"
            width="888"
            height="183"
            className="w-[75%] h-auto mx-auto mb-8"
        />

        <Card>
            <ButtonBar
                className="mb-4"
                buttons={[
                    {label: 'Login', selected: true, onClick: () => null},
                    {label: 'Register', onClick: () => navigate('/register')},
                ]}
            />
            <Form onSubmit={login}>
                <TextField type="email" name="email" label="Email" validators={[RequiredValidator, EmailAddressValidator]} />
                <Password label="Password" name="password" validators={[RequiredValidator]} />
                <Actions submit={{label: 'Login'}}
                    left={<Link to="/forgotten-password" className="inline-block mt-4 text-muted">Forgot password?</Link>}
                />
            </Form>
        </Card>
    </>;
}

export default Login;
